import { useSelector } from 'react-redux';
import {
    getLastMapClickPosition,
    getNearEventsRadius,
} from '../../../../selectors';

export const useMapCoordinates = () => useSelector(getLastMapClickPosition);
export const useNearEventsRadius = () => useSelector(getNearEventsRadius);
